"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("../../common");
const uiSchema = {
    type: "VerticalLayout",
    elements: [
        {
            type: "HorizontalLayout",
            elements: [
                {
                    type: "Control",
                    scope: "#/properties/visitDate",
                    options: {
                        disableFuture: true,
                    },
                },
                { type: "Control", scope: "#/properties/physicianName" },
            ],
        },
        {
            type: "HorizontalLayout",
            elements: [
                { type: "Control", scope: "#/properties/contactPerson" },
                {
                    type: "HorizontalLayout",
                    scope: "#/properties/phoneNumberWithCountryCode",
                    elements: [
                        {
                            type: "Control",
                            scope: "#/properties/phoneNumberWithCountryCode/properties/countryCode",
                            label: "Code",
                        },
                        {
                            type: "Control",
                            scope: "#/properties/phoneNumberWithCountryCode/properties/phoneNumber",
                            label: "Phone Number",
                        },
                    ],
                },
            ],
        },
        {
            type: "Control",
            scope: "#/properties/nextDoctorVisit",
            options: {
                disablePast: true,
            },
        },
        (0, common_1.makeAppointmentUiSchema)("clinicianAppointment", "Next Clinician Visit", {
            disablePast: true,
        }),
        (0, common_1.makeAppointmentConflictsUiSchema)("clinicianAppointment"),
        {
            type: "Control",
            scope: "#/properties/frequency",
        },
        { type: "Control", scope: "#/properties/notes" },
    ],
};
exports.default = uiSchema;
